import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
const CalendarContext = createContext();

export const useCalendar = () => {
  return useContext(CalendarContext);
};

export const CalendarProvider = ({ children }) => {
  const [currentMonthIdx, setCurrentMonthIdx] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [currentMonth, setCurrentMonth] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [view, setView] = useState("month");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [createButtonModal, setcreateButtonModal] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [weekDays, setWeekDays] = useState([]);

  const [showModalmeeting, setShowModalmeeting] = useState(false);
  const [showRoomModal, setShowRoomModal] = useState(false);
  const [selectedTimeSlot, setselectedTimeSlot] = useState(null);

  const [createroomButtonModal, setCreateroomButtonModal] = useState(false);
  const [modaltoogleOption, SetModaltoogleoption] = useState("meeting");
  const [meetingType, setMeetingtype] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const [room, Setroom] = useState([]);
  const [position, setPosition] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const closeEventModal = () => {
    console.log("clicked");
    setShowModal(false);
    setShowMeetingDropdown(false);
  };

  const handlePrevWeek = () => {
    setShowMeetingDropdown(false);
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(prevDate.getDate() - 7); // Subtract 7 days to go to the previous week

      const newMonth = newDate.getMonth(); // Get the new month index
      const newYear = newDate.getFullYear(); // Get the new year

      setCurrentYear(newYear); // Update the year state
      setCurrentMonthIdx(newMonth); // Update the month index state

      return newDate; // Return the updated date
    });
  };

  const handleNextWeek = () => {
    setShowMeetingDropdown(false);
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(prevDate.getDate() + 7); // Add 7 days to go to the next week

      const newMonth = newDate.getMonth(); // Get the new month index
      const newYear = newDate.getFullYear(); // Get the new year

      setCurrentYear(newYear); // Update the year state
      setCurrentMonthIdx(newMonth); // Update the month index state

      return newDate; // Return the updated date
    });
  };

  const formatTime = (hour) => {
    const time = new Date();
    time.setHours(hour, 0, 0);
    return time.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatTime2 = (timeString) => {
    // Split the time string into hours and minutes
    const [hour, minute] = timeString.split(":").map(Number);

    // Create a Date object and set the hours and minutes
    const time = new Date();
    time.setHours(hour, minute, 0);

    // Format the time using toLocaleString
    return time.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const createTimeRangeOptions = () => {
    const options = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 60) {
        const startTime = formatTime(i, j);
        const endTime = formatTime(i + 1, j);
        options.push(`${startTime} - ${endTime}`);
      }
    }
    return options;
  };

  const timeRangeOptions = createTimeRangeOptions();
  const generateMonth = (monthIndex, year) => {
    const firstDayOfMonth = new Date(year, monthIndex, 1);
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    const startDayOfWeek = firstDayOfMonth.getDay();

    const monthDays = [];
    let week = [];

    for (let i = 0; i < startDayOfWeek; i++) {
      week.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      week.push(new Date(year, monthIndex, day));

      if (week.length === 7) {
        monthDays.push(week);
        week = [];
      }
    }

    if (week.length > 0) {
      while (week.length < 7) {
        week.push(null);
      }
      monthDays.push(week);
    }

    return monthDays;
  };

  useEffect(() => {
    setCurrentMonth(generateMonth(currentMonthIdx, currentYear));
  }, [currentMonthIdx, currentYear]);
  const getStartOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    d.setDate(d.getDate() - day);
    return d;
  };
  const handlePrevMonth = () => {
    setShowMeetingDropdown(false);
    setCurrentMonthIdx((prevIdx) => {
      let newMonth = prevIdx - 1;
      let newYear = currentYear;

      if (newMonth < 0) {
        newMonth = 11;
        newYear = currentYear - 1;
      }

      setCurrentYear(newYear);
      return newMonth;
    });
  };

  const handleNextMonth = () => {
    setCurrentMonthIdx((prevIdx) => {
      let newMonth = prevIdx + 1;
      let newYear = currentYear;

      if (newMonth > 11) {
        newMonth = 0;
        newYear = currentYear + 1;
      }
      setShowMeetingDropdown(false);
      setCurrentYear(newYear);
      return newMonth;
    });
  };

  const handleToday = () => {
    const today = new Date();

    setSelectedDate(today);

    setCurrentMonthIdx(today.getMonth());
    setCurrentYear(today.getFullYear());
  };
  const [clickedDay, setClickedDay] = useState(null);

  const handleDayClick = (date, idx) => {
    console.log("clicked day for meeting create", idx);
    setShowMeetingDropdown(false);
    // Set the position based on the index
    if (idx < 2) {
      setPosition("right");
    } else {
      setPosition("left");
    }

    // Set the selected date
    setSelectedDate(date);

    // Get the current time
    const currentTime = new Date();

    // Round the current time to the nearest 15 minutes
    const roundedMinutes = Math.ceil(currentTime.getMinutes() / 15) * 15;
    const roundedTime = new Date(currentTime);
    roundedTime.setMinutes(roundedMinutes, 0, 0);

    // If rounding exceeds 60 minutes, adjust the hour
    if (roundedTime.getMinutes() === 60) {
      roundedTime.setMinutes(0);
      roundedTime.setHours(roundedTime.getHours() + 1);
    }

    // Set the start time to the rounded time
    const clickedStartTime = new Date(date);
    clickedStartTime.setHours(
      roundedTime.getHours(),
      roundedTime.getMinutes(),
      0,
      0
    );

    // Set the end time to 15 minutes after the start time
    const clickedEndTime = new Date(clickedStartTime);
    clickedEndTime.setMinutes(clickedStartTime.getMinutes() + 15);

    // Format the start and end times
    const startTime =
      clickedStartTime
        .toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .split(":")
        .slice(0, 2)
        .join(":") + "";

    const endTime =
      clickedEndTime
        .toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .split(":")
        .slice(0, 2)
        .join(":") + "";

    console.log(startTime, endTime);

    // Set the selected time slot
    setselectedTimeSlot({
      start: startTime,
      end: endTime,
    });

    // Show the modal
    setShowModal(true);
  };

  const handleDayMoreMeetingclicked = (date, idx) => {
    // console.log(date, "date after cliking more meeeting");
    const eventDate = new Date(date);

    setSelectedDate(date);
    setView("day");
    setIsAccordionOpen(false);
    setShowFilterMenu(false);
    setShowMeetingDropdown(false);
  };

  const handleDayClicksidebar = (date) => {
    setSelectedDate(date);
    setCurrentTime(new Date());
    setView("day");
    setIsAccordionOpen(false);
    setShowFilterMenu(false);
    setShowMeetingDropdown(false);
  };

  const handleViewChange = (event) => {
    setView(event.target.value);
    setIsAccordionOpen(false);
    setShowFilterMenu(false);
    setShowMeetingDropdown(false);
  };

  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
  };

  const handleopenRoomModal = (date) => {
    setShowRoomModal(true);
  };

  const closeMeetingModal = () => {
    console.log("clicked");
    setShowModalmeeting(false);
  };

  const handlecloseRoomModal = (date) => {
    setShowRoomModal(false);
  };

  useEffect(() => {
    const days = [];
    const start = getStartOfWeek(currentDate);

    for (let i = 0; i < 7; i++) {
      days.push(addDays(start, i));
    }
    setWeekDays(days);
  }, [currentDate]);
  const handleTimeSlotClick = (hour) => {
    console.log(hour);
    const clickedStartTime = new Date(selectedDate);

    clickedStartTime.setHours(hour, 0, 0, 0);
    // console.log("Start Time: ", clickedStartTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));

    const clickedEndTime = new Date(clickedStartTime);
    clickedEndTime.setHours(clickedStartTime.getHours() + 1);
    // console.log("End Time: ", clickedEndTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));

    setselectedTimeSlot({
      start: clickedStartTime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
      end: clickedEndTime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    });

    setShowModal(true);
  };

  const handleTimeSlotClickweek = (hour, date) => {
    console.log(hour);
    const weekdate = new Date(date);
    setSelectedDate(weekdate);
    const clickedStartTime = new Date(selectedDate);

    clickedStartTime.setHours(hour, 0, 0, 0);
    // console.log("Start Time: ", clickedStartTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));

    const clickedEndTime = new Date(clickedStartTime);
    clickedEndTime.setHours(clickedStartTime.getHours() + 1);
    // console.log("End Time: ", clickedEndTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));

    setselectedTimeSlot({
      start: clickedStartTime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
      end: clickedEndTime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    });

    setShowModal(true);
  };
  const timeSlots = Array.from({ length: 24 }, (_, hour) => {
    return [0, 15, 30, 45].map((minute) => ({
      hour,
      minute,
      timeString: `${String(hour).padStart(2, "0")}:${String(minute).padStart(
        2,
        "0"
      )}`,
    }));
  }).flat();
  console.log(timeSlots, "timeslots");

  const handleCreateRoomButtonClick = () => {
    console.log("clicked");
    setCreateroomButtonModal(true);
  };

  const handleCloseRoomModal = () => {
    setCreateroomButtonModal(false);
  };

  const handleRoomCreated = (roomData) => {
    Setroom([...room, roomData]);
    setCreateroomButtonModal(false);
  };

  const handlechooseToogleoption = (Option) => {
    console.log(Option, "clicked");
    setShowModalmeeting(true);
    SetModaltoogleoption(Option);
    // setShowModal(false)
  };
  const getWeekDateRange = () => {
    const startOfWeek = new Date(selectedDate);
    const dayOfWeek = startOfWeek.getDay(); // Sunday is 0, Monday is 1, etc.

    // If today is Sunday (dayOfWeek is 0), move it back 6 days to get the previous Monday
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust so the start is always Monday
    startOfWeek.setDate(startOfWeek.getDate() + diff);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // end of the week is 6 days after Monday

    return `${startOfWeek.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    })} - ${endOfWeek.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })}`;
  };

  const handleTimeRangeChange = (e) => {
    setTimeRange(e.target.value);
  };

  const handleSelectMeetingType = (e) => {
    setMeetingtype(e.target.value);
  };

  const handlePrevDay = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);

      newDate.setDate(newDate.getDate() - 1);

      const newMonthIdx = newDate.getMonth();
      const newYear = newDate.getFullYear();

      setCurrentMonthIdx(newMonthIdx);
      setCurrentYear(newYear);
      setShowMeetingDropdown(false);
      return newDate;
    });
  };

  const handleNextDay = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);

      newDate.setDate(newDate.getDate() + 1);

      const newMonthIdx = newDate.getMonth();
      const newYear = newDate.getFullYear();

      setCurrentMonthIdx(newMonthIdx);
      setCurrentYear(newYear);
      setShowMeetingDropdown(false);
      return newDate;
    });
  };

  const [roomData, setRoomData] = useState("");
  const getRoomdata = async () => {
    const result = await axios.get(`${BASE_URL}/meetingscheduler/meetingroom/`);

    setRoomData(result.data);
  };

  const [meetingData, setMeetingData] = useState("");
  const getMeetingData = async () => {
    const result = await axios.get(
      `${BASE_URL}/meetingscheduler/meetingbyparticipent/${sessionStorage.getItem(
        "emp_code"
      )}/`
    );
    setMeetingData(result.data);
  };

  const getMeetingDatafilter = async (date, room) => {
    const result = await axios.get(
      `${BASE_URL}/meetingscheduler/meetingfilter/${date}/${room}/`
    );
    setMeetingData(result.data);
  };

  const Applyfilters = (date, room) => {
    getMeetingDatafilter(date, room);
    setShowFilterMenu(!showFilterMenu);
  };

  const ResetFilters = (date, room) => {
    setShowFilterMenu(!showFilterMenu);
    getMeetingData();
  };

  useEffect(() => {
    getRoomdata();
    getMeetingData();
  }, []);

  const [showMeetingDropdown, setShowMeetingDropdown] = useState(false);

  const [filters, setFilters] = useState({
    showPastMeetings: true,
    showMyMeetings: true,
    showTeamMeetings: true,
  });

  const toggleMeetingDropdown = () => {
    setShowMeetingDropdown(!showMeetingDropdown);
  };

  const handleFilterChange = (filterName) => {
    setFilters({
      ...filters,
      [filterName]: !filters[filterName],
    });
  };
  const [Upcomingmeetinglist, SetUpcomingmeetinglist] = useState([]);

  const getRelevantMeetings = () => {
    if (!selectedDate || !meetingData) {
      SetUpcomingmeetinglist([]);
      return;
    }

    const formatDate = (date, format = "YYYY-MM-DD") => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");

      if (format === "YYYY-MM-DD") {
        return `${year}-${month}-${day}`;
      } else if (format === "MM/DD/YYYY") {
        return `${month}/${day}/${year}`;
      } else {
        return d.toLocaleDateString();
      }
    };

    let filteredMeetings = [];

    switch (view) {
      case "day":
        filteredMeetings = meetingData.filter((meeting) => {
          console.log(
            meeting.meeting_date === formatDate(selectedDate),
            meeting.meeting_date,
            selectedDate,
            formatDate(selectedDate)
          );
          return meeting.meeting_date === formatDate(selectedDate);
        });
        break;

      case "week":
        const weekStart = new Date(selectedDate);
        weekStart.setDate(selectedDate.getDate() - selectedDate.getDay());

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        filteredMeetings = meetingData.filter((meeting) => {
          const meetingDate = new Date(meeting.meeting_date);
          return meetingDate >= weekStart && meetingDate <= weekEnd;
        });
        break;

      case "month":
        filteredMeetings = meetingData.filter((meeting) => {
          const meetingDate = new Date(meeting.meeting_date);
          return (
            meetingDate.getMonth() === currentMonthIdx &&
            meetingDate.getFullYear() === currentYear
          );
        });
        break;

      default:
        filteredMeetings = [];
        break;
    }

    SetUpcomingmeetinglist(filteredMeetings);
  };

  useEffect(() => {
    console.log("useffect changeds");
    getRelevantMeetings();
  }, [selectedDate, view, meetingData, currentMonthIdx, currentYear]);

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const today = new Date();
  const todayDate = today.getDate();
  const todayMonth = today.getMonth();
  const todayYear = today.getFullYear();

  const [showViewmeetingModal, setViewMeetingModal] = useState(false);

  const [eventId, setEventid] = useState(false);
  const handleShow = (id, idx) => {
    console.log(idx);
    if (idx < 3) {
      setPosition("right");
    } else {
      setPosition("left");
    }
    setViewMeetingModal(true);

    setEventid(id);
  };

  const handleclose = () => {
    console.log("handle close clicked");
    setViewMeetingModal(false);
  };

  const MAX_MEETINGS_TO_SHOW = 4;
  const getRandomColor = (id) => {
    const colors = [
      // "#FF6F61", // Coral Red
      "#4CAF50", // Medium Green
      "rgb(48, 201, 201) ",
      "rgb(255, 116, 124)",
      // "rgb(247, 186, 30)",

      // Light Blue
      "rgb(24, 161, 24)",

      // "#43A047", // Green
      // "#D32F2F", // Red
      // "#8E24AA", // Violet
      // "#00B8D4", // Cyan
      // "#FF5722", // Deep Orange

      "#FF9800", // Orange
      "#9C27B0", // Deep Purple
      "#00E676", // Bright Green
      "#3F51B5", // Indigo
      "#F44336", // Red
      "#2196F3", // Blue
    ];

    // Return a color based on the ID
    return colors[id % colors.length];
  };

  const [showViewmeetingModalAll, SetShowViewmeetingModalAll] = useState(false);
  const [showModalresponse, SetShowModalresponse] = useState(false);
  const [MeetingResponseData, SetMeetingResponseData] = useState(false);
  const handleshowMeetingresponse = (data) => {
    SetShowModalresponse(!showModalresponse);
    SetMeetingResponseData(data);
  };
  // useEffect(() => {
  //   console.log(showViewmeetingModalAll, "View meeting modal alll");
  // }, [showViewmeetingModalAll]);

  // new context to provide
  const [selectedEvent, SetSelectedEvent] = useState("");
  const [selectedEventupdate, SetSelectedEventupdate] = useState([]);
  const [selectedEventmini, SetSelectedEventmini] = useState([]);
  const [selectedEventDetail, SetSelectedEventDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalupdate, setShowModalupdate] = useState(false);

  const [showModaldetail, setShowModaldetail] = useState(false);

  function clickOnEventName(evt, monthIndex) {
    console.log(evt, "meetingdata");
    SetSelectedEvent(evt);
    setShowModalupdate(true);
    setShowMeetingDropdown(false);
  }

  function handleClickOnEventName(evt, monthIndex) {
    setShowMeetingDropdown(false);
    clickOnEventName(evt, monthIndex, events);
  }

  function withStopPropagation(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    return cb;
  }
  const [isShowAllEventDatemini, setShowAllEventDatemini] = useState(false);
  function handleShowAllEvent(e, events, day) {
    e.stopPropagation();
    setShowAllEventDatemini(true);
    if (day) {
      setSelectedDate(day);
    }

    SetSelectedEventmini(events);
    setShowModal(false);
    setShowModaldetail(false);
  }
  function handleShowAllEventDetail(e, events, day) {
    e.stopPropagation();
    setShowModaldetail(true);
    setShowModal(false);
    console.log(events);
    if (day) {
      setSelectedDate(day);
    }
    // SetSelectedEventupdate(events)
    setShowAllEventDatemini(false);
    SetSelectedEventDetail(events);
    setShowMeetingDropdown(false);
  }

  function handleShowAllUpdate(e, events) {
    e.stopPropagation();
    setShowModalupdate(true);
    console.log(events);
    SetSelectedEventupdate(events);
  }

  function renderHour(hour) {
    return hour > 12 ? Math.floor(hour - 12) : hour;
  }

  function getStatus(hour) {
    if (hour === 0) {
      return "AM";
    } else if (hour > 12) {
      return "PM";
    } else {
      return "AM";
    }
  }

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const handleToggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
    setShowMeetingDropdown(false);
  };

  const filterItems = [
    { id: "All", label: "All", color: "rgb(34, 127, 182)" },
    { id: "accepted", label: "Accepted", color: "rgb(77, 190, 51)" },
    { id: "pending", label: "Pending", color: "rgb(116, 128, 166)" },
    { id: "rejected", label: "Rejected", color: "rgb(238, 68, 68)" },
  ];
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const toggleFilterMenu = () => {
    setShowFilterMenu(!showFilterMenu);
    setShowMeetingDropdown(false);
  };

  const Handlecloseallmodal = () => {
    setShowModal(false);
    setShowAllEventDatemini(false);
    setShowModaldetail(false);
    setShowModalupdate(false);
  };
  return (
    <CalendarContext.Provider
      value={{
        currentMonthIdx,
        isShowAllEventDatemini,
        selectedEventmini,
        filterItems,
        isAccordionOpen,
        showFilterMenu,
        showModaldetail,
        selectedEventDetail,
        selectedEventupdate,
        currentYear,
        currentMonth,
        events,
        view,
        weekDays,
        selectedDate,
        createButtonModal,
        showModal,
        showModalupdate,
        timeSlots,
        selectedTimeSlot,
        createroomButtonModal,
        modaltoogleOption,
        currentTime,
        timeRange,
        timeRangeOptions,
        meetingType,
        showRoomModal,
        roomData,
        clickedDay,
        showModalmeeting,
        position,
        meetingData,
        isSidebarOpen,
        showModaldetail,
        showFilterMenu,
        filters,
        showMeetingDropdown,
        daysOfWeek,
        today,
        todayDate,
        todayMonth,
        todayYear,
        showViewmeetingModal,
        eventId,
        MAX_MEETINGS_TO_SHOW,
        showModalresponse,
        MeetingResponseData,
        showViewmeetingModalAll,
        Upcomingmeetinglist,

        // all function passed here
        closeMeetingModal,
        setselectedTimeSlot,
        setWeekDays,
        getStartOfWeek,
        addDays,
        renderHour,
        getStatus,
        setselectedTimeSlot,
        SetSelectedEventDetail,
        getRelevantMeetings,
        toggleFilterMenu,
        handleToggleAccordion,
        setShowAllEventDatemini,
        handleShowAllEvent,
        handleShowAllEventDetail,
        setShowModaldetail,
        handleShowAllUpdate,
        handleFilterChange,
        setSelectedDate,
        setShowModal,
        setShowModalupdate,
        closeEventModal,
        setcreateButtonModal,
        handlePrevMonth,
        handleNextMonth,
        handlePrevDay,
        handleNextDay,
        handleToday,
        handleDayClick,
        handleDayClicksidebar,
        handleViewChange,
        handleTimeSlotClick,
        handleCreateRoomButtonClick,
        handleCloseRoomModal,
        handleRoomCreated,
        handlechooseToogleoption,
        setCurrentTime,
        handleTimeRangeChange,
        formatTime,
        formatDate,
        handleSelectMeetingType,
        handlecloseRoomModal,
        handleopenRoomModal,
        getRoomdata,
        getMeetingData,
        setShowRoomModal,
        handlePrevWeek,
        handleNextWeek,
        getWeekDateRange,
        handleTimeSlotClickweek,
        toggleSidebar,
        setPosition,

        toggleMeetingDropdown,

        setViewMeetingModal,
        handleShow,
        handleclose,

        getRandomColor,
        toggleFilterMenu,
        Applyfilters,
        ResetFilters,

        formatTime2,

        SetShowViewmeetingModalAll,
        handleDayMoreMeetingclicked,
        handleshowMeetingresponse,
        handleClickOnEventName,
        withStopPropagation,
        Handlecloseallmodal,
        handleShowAllEvent,
      }}
    >
      {children}
    </CalendarContext.Provider>
  );
};
